import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { POLICY_ADDRESS, PolicyEmail } from "./PolicyPage";

function Privacy() {
  return (
    <PolicyPage
      title="Privacy policy"
      intro="This policy explains what personal information slayfulpawsco handles when you browse, contact us, or place an order, why we use it, and the choices available to you."
    >
      <h2>Scope and controller</h2>
      <p>
        This policy applies to this slayfulpawsco storefront, its checkout flow,
        customer-support communications, and order administration. For privacy
        questions, contact <PolicyEmail subject="Privacy question" />.
      </p>

      <h2>Information we handle</h2>
      <ul>
        <li><strong>Contact information:</strong> name, email address, phone number, company name, and messages you send.</li>
        <li><strong>Order and delivery information:</strong> products, quantities, selected options, order number, delivery address, shipping choice, and transaction status.</li>
        <li><strong>Payment information:</strong> the payment provider processes card and payment credentials. We do not intend to receive or store your full card number or security code.</li>
        <li><strong>Device and usage information:</strong> IP address, browser and device details, referring pages, timestamps, security events, and server logs that may be generated by the site or its service providers.</li>
        <li><strong>Local cart information:</strong> product identifiers, quantities, sizes, and colors saved in your browser so your cart remains available.</li>
      </ul>

      <h2>How information is collected</h2>
      <p>
        We receive information directly from you, automatically from your
        browser or device, and from providers that support payment, hosting,
        fraud prevention, delivery, and customer service. Details entered into
        the contact or checkout forms may be processed to validate and complete
        your request.
      </p>

      <h2>Why we use information</h2>
      <ul>
        <li>to provide the storefront, remember a cart, and complete requested transactions;</li>
        <li>to confirm, fulfill, deliver, cancel, return, or refund an order;</li>
        <li>to answer questions and maintain customer-service records;</li>
        <li>to detect fraud, secure the service, troubleshoot errors, and enforce our policies;</li>
        <li>to keep tax, accounting, transaction, and compliance records; and</li>
        <li>to send optional marketing only with any permission required by law.</li>
      </ul>
      <p>
        Where a legal basis is required, we rely as appropriate on performance
        of a contract, steps requested before a contract, legitimate interests
        in operating and protecting the store, consent, and compliance with
        legal obligations.
      </p>

      <h2>When information is disclosed</h2>
      <p>
        We may disclose only the information reasonably needed to payment
        processors, hosting and security providers, delivery and fulfillment
        partners, communication providers, professional advisers, and public
        authorities where legally required. Providers may act under their own
        privacy notices when they determine how they process information.
      </p>
      <p>
        We may also transfer relevant records as part of a genuine financing,
        reorganization, merger, acquisition, or sale, subject to appropriate
        confidentiality and applicable law.
      </p>

      <h2>Sale, sharing, and targeted advertising</h2>
      <p>
        Based on the current storefront configuration, slayfulpawsco does not
        sell personal information for money and does not share it for
        cross-context behavioral advertising. We do not currently use
        advertising trackers to build profiles across unrelated websites. See
        <Link to="/privacy-choices"> Your Privacy Choices</Link> for requests and
        browser signals.
      </p>

      <h2>Retention</h2>
      <p>
        We keep information only as long as reasonably necessary for the
        purposes above. Retention depends on the type of record, order and
        support needs, security concerns, limitation periods, and tax,
        accounting, or other legal requirements. Local cart data remains on
        your device until you clear it or your browser removes it.
      </p>

      <h2>International processing</h2>
      <p>
        Providers may process information in countries other than your own.
        Where required, we use an approved transfer mechanism or another lawful
        safeguard. Mandatory privacy protections in your place of residence are
        not limited by this policy.
      </p>

      <h2>Your rights and choices</h2>
      <p>
        Depending on your location, you may have rights to know or access,
        correct, delete, restrict or object to processing, receive a portable
        copy, withdraw consent, opt out of certain transfers or advertising,
        and appeal a decision. You may also complain to your local privacy
        regulator. We will not discriminate against you for exercising an
        applicable privacy right. Instructions are in our
        <Link to="/privacy-choices"> Privacy Choices policy</Link>.
      </p>

      <h2>Security</h2>
      <p>
        We use reasonable administrative and technical safeguards appropriate
        to the information handled. No internet transmission or storage system
        can be guaranteed completely secure. Please do not send card numbers,
        passwords, government identifiers, or other unnecessary sensitive data
        by email or through the contact form.
      </p>

      <h2>Children</h2>
      <p>
        The store is intended for a general audience and is not directed to
        children who cannot lawfully consent to data processing. We do not
        knowingly request personal information from such children. A parent or
        guardian may contact us about a concern.
      </p>

      <h2>Changes and contact</h2>
      <p>
        We may revise this policy when the store, providers, or legal
        requirements change. The date above identifies the latest version.
        Contact <PolicyEmail subject="Privacy request" /> with questions or a
        privacy request.
      </p>
      <p><strong>Mailing address:</strong> {POLICY_ADDRESS}</p>
    </PolicyPage>
  );
}

export default Privacy;
